import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Server, Copy } from 'lucide-react';

interface ZoneNameserversProps {
  nameservers: string[];
}

const ZoneNameservers: React.FC<ZoneNameserversProps> = ({ nameservers }) => {
  const [copySuccess, setCopySuccess] = useState<string | null>(null);

  const copyToClipboard = async (text: string, index: number) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopySuccess(`ns-${index}`);
      setTimeout(() => setCopySuccess(null), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setCopySuccess(`ns-${index}`);
        setTimeout(() => setCopySuccess(null), 2000);
      } catch (fallbackErr) {
        console.error('Fallback copy failed: ', fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  if (!nameservers || nameservers.length === 0) {
    return (
      <div>
        <h3 className="text-heading-2 text-slate-900 dark:text-white mb-3">Nameservers</h3>
        <p className="text-body-small text-slate-500 dark:text-slate-400 text-center py-4">
          No nameservers configured
        </p>
      </div>
    );
  }

  return (
    <div>
      <h3 className="text-heading-2 text-slate-900 dark:text-white mb-3">Nameservers</h3>
      <div className="space-y-2">
        {nameservers.map((ns, index) => (
          <motion.div
            key={index}
            className="flex items-center justify-between p-3 bg-slate-50 dark:bg-slate-800/50 rounded-lg group"
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                <Server className="w-4 h-4 text-blue-600 dark:text-blue-400" />
              </div>
              <span className="text-body font-mono text-slate-700 dark:text-slate-300">
                {ns}
              </span>
            </div>
            <motion.button
              className="inline-flex items-center justify-center p-2 text-slate-500 hover:text-slate-700 hover:bg-slate-50 focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 rounded-lg transition-colors focus:outline-none opacity-0 group-hover:opacity-100 transition-opacity"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => copyToClipboard(ns, index)}
              title="Copy nameserver"
            >
              <Copy className="w-3 h-3" />
            </motion.button>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ZoneNameservers;